const stats = [
  { icon: 'ri-user-heart-line', value: '5,000+', label: '누적 간병 서비스 건수' },
  { icon: 'ri-shield-check-line', value: '98%', label: '고객 만족도' },
  { icon: 'ri-time-line', value: '24시간', label: '연중무휴 상담 가능' },
  { icon: 'ri-map-pin-2-line', value: '전국', label: '어디서든 서류 발급' },
];

export default function StatsSection() {
  return (
    <section className="w-full bg-white py-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((s, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center py-6 px-4 rounded-2xl"
              style={{ backgroundColor: i % 2 === 0 ? '#f4faf8' : '#fff', border: '1px solid #e8f5f1' }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-3"
                style={{ backgroundColor: '#e8f5f1' }}
              >
                <i className={`${s.icon} text-xl`} style={{ color: '#2E7D6B' }}></i>
              </div>
              <p className="text-2xl font-bold" style={{ color: '#2E7D6B' }}>{s.value}</p>
              <p className="text-xs text-gray-500 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}